import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedDate, FormattedTime } from 'react-intl';
import * as actions from 'Actions';
import {
  periodToPricingType,
  displayPeriodUnit,
  customerDeliveryTypes,
} from 'Constants/displayConstants';
import { ListView, ImageView, Burst } from 'Utils/SvgIcons';
import {
  getProductType,
  hasSelectedFlatPrice,
  getSelectedFlatPrice,
} from 'HelperFunctions/rental_items';
import { getFirstAvailablePricingType } from 'HelperFunctions/rentals';
import { formatPhoneNumber } from 'HelperFunctions/general';
import moment from 'moment';
import CurrencyFormatter from 'HelperFunctions/CurrencyFormatter';
import classnames from 'classnames';
import CartItem from './CartItem';
import { combineDateAndTime, toNumber } from 'HelperFunctions/general';
import { showSelectedPrice } from 'HelperFunctions/rental_items';
import AutobookPayment from 'Components/events/AutobookPayment';
import SignatureModal from 'Utils/SignatureModal';
import SignInForm from 'Components/home/SignInForm';
import SignUpForm from 'Components/home/SignUpForm';
import Modal from 'Utils/Modal';
import axios from 'axios';
import CartItems from './CartItems';

class EventSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTiles: true,
      newCustomer: this.props.newCustomer,
      width: 800,
      transactionParams: {},
      signatureOpen: false,
      autobookPaymentStage: this.props.authenticated
        ? 'customerLoggedIn'
        : 'customerNotLoggedIn',
      signInOpen: false,
      signUpOpen: false,
      signatureDetails: {
        name: '',
        submittedAt: '',
      },
      period: '',
      agreement: '',
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.setState({
          width: window.innerWidth,
        });
      });
    }
    this.loadAgreement();
  }

  loadAgreement = () => {
    const { location } = this.props;
    if (location && location.hasAgreement) {
      axios
        .get(
          `${process.env.REACT_APP_API_DOMAIN}/api/portal/locations/${location.id}/default_agreement`
        )
        .then((response) => {
          this.setState({
            agreement: response.data.description,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  toTimeString = (date) =>
    new Date(date).toLocaleTimeString([], {
      hour: 'numeric',
      minute: 'numeric',
    });

  setTileState = (value) => {
    this.setState({
      showTiles: value,
    });
  };

  toggleSignatureOpen = () => {
    this.setState({
      signatureOpen: !this.state.signatureOpen,
    });
  };

  handleSubmitSignature = ({ signature, signerName, signerTitle }) => {
    const { setEventProperties, event, newCustomer, customer } = this.props;
    const firstName = newCustomer?.firstName || customer?.firstName;
    const lastName = newCustomer?.lastName || customer?.lastName;
    const newEvent = Object.assign(event, {
      rentalSignaturesAttributes: [
        {
          signature,
          signerName,
          signerTitle,
          signatureType: 'customer',
        },
      ],
    });
    setEventProperties(newEvent);
    this.setState({
      signatureOpen: false,
      signatureDetails: {
        name: `${firstName} ${lastName}`,
        submittedAt: `${new Date()
          .toISOString()
          .replace(/-/g, '/')
          .replace('T', ' ')
          .replace('Z', ' UTC')}`,
      },
    });
  };

  handleSignIn = (data) => {
    const component = this;
    const { loginUser } = component.props;
    loginUser({
      ...data,
      onSuccess: () => {
        component.setState({
          signInOpen: false,
          signUpOpen: false,
          autobookPaymentStage: 'customerLoggedIn',
        });
        this.props.changeWillPayNowAndReserve(true);
      },
    });
  };

  handleSignUp = (data) => {
    const component = this;
    const { createUser, newEvent } = component.props;
    const { customer } = this.state;

    if (newEvent && newEvent.id && customer) {
      data = Object.assign({
        ...data,
        fromCart: true,
        clientId: customer.clientId,
      });
    }

    createUser({
      ...data,
      onSuccess: () => {
        component.setState({
          signInOpen: false,
          signUpOpen: false,
          autobookPaymentStage: 'customerLoggedIn',
        });
        this.props.changeWillPayNowAndReserve(true);
      },
    });
  };

  closeSignIn = () => {
    this.setState({
      signInOpen: false,
    });
  };

  closeSignUp = () => {
    this.setState({
      signUpOpen: false,
    });
  };

  goToGuestPayAndReserve = () => {
    this.setState({ autobookPaymentStage: 'guestCheckout' });
    this.props.changeWillPayNowAndReserve(true);
  };

  renderAutobookPayment = () => {
    const { autobookPaymentStage, signatureDetails, signatureOpen, agreement } =
      this.state;
    const { customer, location, event } = this.props;

    if (
      this.props.authenticated
    ) {
      return (
        <>
          {location.signatureRequired && (
            <div className='autobookSection'>
              <label>Order requires signature</label>

              <div className='signaturePad'>
                <a onClick={this.toggleSignatureOpen}>
                  {event?.rentalSignaturesAttributes &&
                    event?.rentalSignaturesAttributes[0]?.signature && (
                      <img
                        src={
                          event?.rentalSignaturesAttributes[0]?.signature
                            ? event?.rentalSignaturesAttributes[0]?.signature
                            : null
                        }
                        alt='Signature'
                      />
                    )}
                  <div className='signatureDetails'>
                    <p>
                      {event?.rentalSignaturesAttributes
                        ? event?.rentalSignaturesAttributes[0]?.signerName
                        : ''}
                    </p>
                  </div>
                </a>
              </div>
              <SignatureModal
                open={signatureOpen}
                toggle={this.toggleSignatureOpen}
                rental={{
                  rentalAgreement: agreement,
                  signature: event?.rentalSignaturesAttributes
                    ? event?.rentalSignaturesAttributes[0]?.signature
                    : '',
                  signerName: '',
                  signerTitle: '',
                  signerCompany: '',
                }}
                onSubmitSignature={this.handleSubmitSignature}
              />
            </div>
          )}
          <div
            className='autobookPayment'
            style={{ gridRow: location.signatureRequired ? 3 : 2 }}
          >
            <AutobookPayment
              rental={event}
              location={location}
              customer={customer}
              mode={'customerLoggedIn'}
              toggleSignInOpen={() => this.setState({ signInOpen: true })}
              toggleSignUpOpen={() => this.setState({ signUpOpen: true })}
              handleReserveQuote={this.props.handleReserveQuote}
            />
          </div>
        </>
      );
    } else {
      return <></>;
    }
  };

  render() {
    const { signInOpen, signUpOpen } =
      this.state;
    const {
      customer,
      event,
      location,
      newCustomer,
      cartConfirmation,
      loadItemsFromEvent,
      deliverySetting: {
        morningStartTime,
        morningEndTime,
        afternoonStartTime,
        afternoonEndTime,
        eveningStartTime,
        eveningEndTime,
      } = {},
    } = this.props;
    const {
      eventStart,
      eventStartTime,
      eventEnd,
      eventEndTime,
      customerContactPhone,
      deliveryType,
      deliveryAddressLocationName,
      deliveryAddressStreetAddress1,
      deliveryAddressStreetAddress2,
      deliveryAddressCity,
      deliveryAddressLocale,
      deliveryAddressPostalCode,
      deliveryAddressCountry,
      pickupAddressLocationName,
      pickupAddressStreetAddress1,
      pickupAddressStreetAddress2,
      pickupAddressCity,
      pickupAddressLocale,
      pickupAddressPostalCode,
      pickupAddressCountry,
      pickupSameAsDelivery,
    } = event;
    if (typeof localStorage === "undefined") return <></>

    const timeZoneElon = moment.tz.guess(eventStartTime);
    const timeZone = moment.tz([2022, 5], timeZoneElon).format('z');
    const smartPricingActive = location.smartPricingActive;
    const locale = location.locale;

    let localFirstName;
    let localLastName;
    let localEmail;
    let localCustomerContactPhone;
    let localItems;
    let eventSchedule;
    if (newCustomer?.firstName) {
      localFirstName = newCustomer.firstName;
      localStorage.setItem('localFirstName', localFirstName);
    }
    if (newCustomer?.lastName) {
      localLastName = newCustomer.lastName;
      localStorage.setItem('localLastName', localLastName);
    }
    if (newCustomer?.email) {
      localEmail = newCustomer.email;
      localStorage.setItem('localEmail', localEmail);
    }
    if (event?.customerContactPhone) {
      localCustomerContactPhone = customerContactPhone;
      localStorage.setItem(
        'localCustomerContactPhone',
        localCustomerContactPhone
      );
    }

    if (
      event?.eventStart &&
      event?.eventEnd &&
      event?.eventStartTime &&
      event?.eventEndTime
    ) {
      eventSchedule = {
        eventStart,
        eventStartTime,
        eventEnd,
        eventEndTime,
      };
      localStorage.setItem('eventSchedule', JSON.stringify(eventSchedule));
    }

    var firstName = localStorage.getItem('localFirstName');
    var lastName = localStorage.getItem('localLastName');
    var email = localStorage.getItem('localEmail');
    var eventCustomerContactPhone = localStorage.getItem(
      'localCustomerContactPhone'
    );
    var storedEventSchedule = JSON.parse(localStorage.getItem('eventSchedule'));

    let deliveryHeader = pickupSameAsDelivery
      ? 'Delivery/Pick Up Info'
      : 'Delivery Info';

    return (
      <section
        className={classnames({
          summary: cartConfirmation !== true,
          confirmationSummary: cartConfirmation === true,
          eventDetails: this.state.width < 768 && cartConfirmation === true,
          stretchToFill: !cartConfirmation && event.additionalInfo && !event.additionalInfo?.show_prices,
        })}
      >
        <div
          className={classnames({
            eventDetails: cartConfirmation !== true,
            confirmationEventDetails: cartConfirmation === true,
          })}
        >
          {!cartConfirmation && (
            <div className='title'>
              <h4 id='eventNameSummary'>{event.name}</h4>
              <div className='eventSchedule'>
                <FormattedDate
                  value={eventStart}
                  month='short'
                  year='numeric'
                  day='numeric'
                />
                <span>-</span>
                <FormattedDate
                  value={eventEnd}
                  month='short'
                  year='numeric'
                  day='numeric'
                />
              </div>
            </div>
          )}
          {cartConfirmation && (
            <div className='title'>
              <h4 id='eventNameSummary'>Order Date</h4>
              <hr className='hr'></hr>
              <div className='confirmationEventSchedule'>
                <div>
                  <text>Order Start</text>
                  <FormattedDate
                    value={eventStart || storedEventSchedule?.eventStart}
                    month='numeric'
                    year='numeric'
                    day='numeric'
                  />{' '}
                  <FormattedTime
                    value={
                      eventStartTime || storedEventSchedule?.eventStartTime
                    }
                  />
                </div>
                <div>
                  <text>Order End</text>
                  <FormattedDate
                    value={eventEnd || storedEventSchedule?.eventEnd}
                    month='numeric'
                    year='numeric'
                    day='numeric'
                  />{' '}
                  <FormattedTime
                    value={eventEndTime || storedEventSchedule?.eventEndTime}
                  />
                </div>
              </div>
            </div>
          )}
          <div className='contactWrapper'>
            {customer.id && (
              <div className='contact'>
                {!cartConfirmation ? (
                  <div>
                    <label>Contact:</label>
                    <strong>
                      {' '}
                      {customer.firstName} {customer.lastName}{' '}
                    </strong>
                  </div>
                ) : (
                  <div>
                    <hr className='hr'></hr>
                    <h4 id='eventNameSummary'>Contact Info</h4>
                    <div>
                      {' '}
                      {customer.firstName} {customer.lastName}{' '}
                    </div>
                  </div>
                )}
                <div>{customer.email}</div>
                <div>
                  <div>
                    {customerContactPhone
                      ? formatPhoneNumber(customerContactPhone)
                      : eventCustomerContactPhone}
                  </div>
                  {customer.streetAddress1 && (
                    <div>
                      {customer.streetAddress1}{' '}
                      {customer.streetAddress2 && (
                        <div>{customer.streetAddress2}</div>
                      )}
                      <div>
                        {customer.city}
                        {', '}
                        {customer.locale} {customer.postalCode}
                        {', '}
                        {customer.country}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {!customer.id && (
              <div className='contact'>
                {!cartConfirmation ? (
                  <div>
                    <label>Contact:</label>
                    <strong>
                      {' '}
                      {firstName} {lastName}{' '}
                    </strong>
                  </div>
                ) : (
                  <div>
                    <hr className='hr'></hr>
                    <h4 id='eventNameSummary'>Contact Info</h4>
                    <div>
                      {' '}
                      {firstName} {lastName}{' '}
                    </div>
                  </div>
                )}
                <div>{email}</div>
                <div>{formatPhoneNumber(eventCustomerContactPhone)}</div>
              </div>
            )}
          </div>
          {deliveryType === 'none' ? (
            ''
          ) : (
            <div className='delivery'>
              {!['default_delivery', 'ship'].includes(deliveryType) && (
                <div>
                  {!cartConfirmation ? (
                    <label>{customerDeliveryTypes[deliveryType]}</label>
                  ) : (
                    <div id='eventNameContainer'>
                      <hr className='hr'></hr>
                      <h4 id='eventNameSummary'>
                        {customerDeliveryTypes[deliveryType]}
                      </h4>
                    </div>
                  )}
                </div>
              )}
              {['default_delivery', 'ship'].includes(deliveryType) && (
                <div>
                  {!cartConfirmation ? (
                    <label>Location:</label>
                  ) : (
                    <div id='eventNameContainer'>
                      <hr className='hr'></hr>
                      <h4 id='eventNameSummary'>{deliveryHeader}</h4>
                    </div>
                  )}
                  <div id='deliveryAddressLocationName'>
                    {deliveryAddressLocationName}
                  </div>
                  <div>
                    {deliveryAddressStreetAddress1}{' '}
                    {deliveryAddressStreetAddress2}
                  </div>
                  <div>
                    {deliveryAddressCity}, {deliveryAddressLocale}{' '}
                    {deliveryAddressPostalCode}, {deliveryAddressCountry}
                  </div>
                </div>
              )}
            </div>
          )}
          {!pickupSameAsDelivery &&
            ['default_delivery', 'custom_delivery'].includes(deliveryType) && (
              <div className='delivery'>
                {!cartConfirmation ? (
                  <label>Pick Up:</label>
                ) : (
                  <div id='pickupConfirmContainer'>
                    <div id='eventNameContainer'>
                      <hr className='hr'></hr>
                      <h4 id='eventNameSummary'>Pick Up Info</h4>
                    </div>
                  </div>
                )}
                <div>
                  <div id='pickupAddressLocationName'>
                    {pickupAddressLocationName}
                  </div>
                  <div>
                    {pickupAddressStreetAddress1} {pickupAddressStreetAddress2}
                  </div>
                  <div>
                    {pickupAddressCity}, {pickupAddressLocale}{' '}
                    {pickupAddressPostalCode}, {pickupAddressCountry}
                  </div>
                </div>
              </div>
            )}
          {!cartConfirmation && (
            <div id='deliveryWindowContainer'>
              <label>Delivery Window:</label>
              <div id='deliveryWindow'>
                <FormattedDate
                  value={eventStart}
                  year='numeric'
                  month='short'
                  weekday='short'
                  day='numeric'
                />
                {event.preferredDeliveryWindow == 'delivery_morning_time' &&
                  `${this.toTimeString(morningStartTime)} - ${this.toTimeString(
                    morningEndTime
                  )} ${timeZone}`}
                {event.preferredDeliveryWindow == 'delivery_afternoon_time' &&
                  `${this.toTimeString(
                    afternoonStartTime
                  )} - ${this.toTimeString(afternoonEndTime)} ${timeZone}`}
                {event.preferredDeliveryWindow == 'delivery_evening_time' &&
                  `${this.toTimeString(eveningStartTime)} - ${this.toTimeString(
                    eveningEndTime
                  )} ${timeZone}`}
                {event.preferredDeliveryWindow == 'delivery_no_preference' &&
                  `No Preference`}
              </div>
            </div>
          )}
          {!cartConfirmation && (
            <div id='returnWindowContainer'>
              <label>Return Window:</label>
              <div id='returnWindow'>
                <FormattedDate
                  value={eventStart}
                  year='numeric'
                  month='short'
                  weekday='short'
                  day='numeric'
                />
                {event.preferredPickupWindow == 'pickup_morning_time' &&
                  `${this.toTimeString(morningStartTime)} - ${this.toTimeString(
                    morningEndTime
                  )} ${timeZone}`}
                {event.preferredPickupWindow == 'pickup_afternoon_time' &&
                  `${this.toTimeString(
                    afternoonStartTime
                  )} - ${this.toTimeString(afternoonEndTime)} ${timeZone}`}
                {event.preferredPickupWindow == 'pickup_evening_time' &&
                  `${this.toTimeString(eveningStartTime)} - ${this.toTimeString(
                    eveningEndTime
                  )} ${timeZone}`}
                {event.preferredPickupWindow == 'pickup_no_preference' &&
                  `No Preference`}
              </div>
            </div>
          )}

          {this.props.step === 3 &&
            this.props.autobookPossible() &&
            this.renderAutobookPayment()}

          <Modal
            className='signInModal'
            title='Sign In'
            open={signInOpen}
            toggle={this.closeSignIn}
          >
            <div>
              <div className='icon'>
                <Burst />
              </div>
              <div className='details'>
                <p>
                  Please sign in/up to,
                  <br />
                  reserve and pay your order.
                </p>
                <SignInForm errors={{}} onSubmit={this.handleSignIn} />
                <a
                  onClick={() =>
                    this.setState({ signInOpen: false, signUpOpen: true })
                  }
                >
                  or Sign Up for FREE
                </a>
              </div>
            </div>
          </Modal>
          <Modal
            className='signInModal'
            title='Sign Up'
            open={signUpOpen}
            toggle={this.closeSignUp}
          >
            <div>
              <div className='icon'>
                <Burst />
              </div>
              <div className='details'>
                <SignUpForm
                  errors={{}}
                  onSubmit={this.handleSignUp}
                  customer={customer}
                />
                <a
                  onClick={() =>
                    this.setState({ signInOpen: true, signUpOpen: false })
                  }
                >
                  or Sign In
                </a>
              </div>
            </div>
          </Modal>
        </div>

        <CartItems cartConfirmation itemsOnly loadItemsFromEvent={loadItemsFromEvent} />
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authenticated } = state.auth;
  const {
    parsedStorefrontSettings: { storefrontShopSetting },
    location,
  } = state.locations;
  const { tileView } = state.products;
  const { customer } = state.customer;
  const { newEvent } = state.cart;

  return {
    customer,
    storefrontShopSetting,
    location,
    tileView,
    authenticated,
    newEvent,
  };
};

export default connect(mapStateToProps, actions)(EventSummary);
